import React from "react";
import playIcon from "../../assets/play.svg";
import pauseIcon from "../../assets/pause.svg";
import "../../styles/components/useroverlay/PlayPauseButton.css";

interface PlayPauseButtonProps {
  isPlaying: boolean;
  onToggle: () => void;
}

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  isPlaying,
  onToggle,
}) => {
  // Show play icon when paused, pause icon when playing
  const iconToShow = isPlaying ? pauseIcon : playIcon;
  const title = isPlaying ? "Pause" : "Play";

  return (
    <button
      className="play-pause-button"
      onClick={onToggle}
      title={title}
      aria-label={title}
    >
      <img src={iconToShow} alt={title} className="play-pause-icon" />
    </button>
  );
};

export default PlayPauseButton;
